import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { ReactComponent as Asigned } from "../Assets/status-assigned.svg";
import { ReactComponent as Pending } from "../Assets/status-pending.svg";
import { ReactComponent as Selected } from "../Assets/status-selected.svg";

const Status = (props) => {
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const verifyStatus = async () => {
    const response = await axios
      .get(`${process.env.REACT_APP_EDAIN_URL}/api/v1/bazaar/partner/private/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`
        }
      })
      .catch((error) => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              toast.info("Please log in again", { toastId: "error-401" });
              localStorage.removeItem("jwt");
              navigate("/login");
              break;
          }
        }
      });

    if (response.status === 200) {
      setStatus(response.data.status);
    }
  };

  useEffect(() => {
    verifyStatus();
  }, []);

  return (
    <div className="status d-flex align-items-center justify-content-center">
      <div className="status-inner text-center p-5">
        {status === "AVAILABLE" || status === "UNAVAILABLE" ? (
          <>
            <h2 className="font-pnsb text-light mb-4">Thank you!</h2>
            <Pending />
            <p className="font-pnsb mb-4 mt-4 font-size-32 text-light">
              Your application is pending. <br /> You will receive an email when <br /> your
              application status has changed.
            </p>
            <a
              rel="noreferrer"
              className="status-gradient m-auto d-flex align-items-center justify-content-center"
              href="https://zixxar.net/">
              <span>Return to website</span>
            </a>
          </>
        ) : status === "UNASSIGNED" ? (
          <>
            <h2 className="font-pnsb text-light mb-4">Congratulations!</h2>
            <Selected />
            <p className="font-pnsb mb-4 mt-4 font-size-32 text-light">
              Your application has been approved. <br /> Please stand by to be assigned <br /> to
              your new team.
            </p>
            <a
              rel="noreferrer"
              className="status-gradient m-auto d-flex align-items-center justify-content-center"
              href="https://zixxar.net">
              <span>Return to website</span>
            </a>
          </>
        ) : status === "ASSIGNED" ? (
          <>
            <h2 className="font-pnsb text-light mb-4">Yohoo!</h2>
            <Asigned />
            <p className="font-pnsb mb-4 mt-4 font-size-32 text-light">
              Your application has been selected. <br /> Please wait for the user to <br />
              assign you to their team.
            </p>
            <a
              rel="noreferrer"
              className="status-gradient m-auto d-flex align-items-center justify-content-center"
              href="https://zixxar.net">
              <span>Return to website</span>
            </a>
          </>
        ) : null}
      </div>
    </div>
  );
};
export default Status;
